<template>
  <v-app>
    <NuxtLayout>
      <NuxtPwaManifest />
      <NuxtRouteAnnouncer />
      <NuxtPage :keepalive="{ include: ['CircleListPage', 'CircleFavoritePage'] }" />
      <!-- API アクセス失敗時に "Server Error" をグローバル表示する -->
      <server-error-banner />
    </NuxtLayout>
  </v-app>
</template>

<script setup lang="ts">
import { setStateFromQueryString } from "~/composables/routeQuery";
import ServerErrorBanner from "~/components/ServerErrorBanner.vue";
import { resolveTimeboxedFeature } from "~/utils/urlHelper";
import { useTrialUplift } from "~/composables/useTrialUplift";
// import FeedBackIcon from "~/components/organisms/FeedBackIcon.vue"; // アンケート導線

const requestURL = useRequestURL();/* Client, Server どちらでも利用可能 */
const route = useRoute();
const initialRouteState = useInitialRouteState();
initialRouteState.setInitialRouteFullpath(requestURL, route); // ログイン処理後の戻り先

// URLのパース結果を State に保存 (config構築を待たなくてよい)
setStateFromQueryString();

// アプリケーション内config の構築 CSR における appEnv の決定が含まれる
useCirclemsConfig();

// provide/inject は DependencyInjection の仕組みだった

if (import.meta.client) {
  useRouter().push(route.fullPath); // yarn generate するスタティックページに必要
}

// △ページ(サークル一覧/詳細・お気に入り・会場マップ)を閲覧中に3分の時限が経過したら /pay?from= へ自動遷移する
const { trialActive } = useTrialUplift();
const onTimeboxedRoute = computed(() => resolveTimeboxedFeature(route.fullPath) !== undefined);
// 「画面遷移」という副作用は computed では表現できないため watch を使う (規約の例外)
// trialActive が true→false に落ちた瞬間 (=3分経過) だけを捕捉する。
// 無制限ロール/未ログインは false のため発火しない。ブロック中トークンで来た場合も (false のままなので) 発火しない
watch(trialActive, async (active, wasActive) => {
  if (wasActive && !active && onTimeboxedRoute.value) {
    // navigateToPaymentStart は既定で forceExternal (フルリロード)。
    // △ページの重い状態 (マップ・一覧等) を破棄する ADR-007 課金導線向け。
    await navigateToPaymentStart({ from: route.fullPath });
  }
});

// 以下はうまくいかなかったため checkPermission に組み込んだ
// ログインを一度試みてから指定されたページにアクセスする
// DOM 描画を待たなくてよいので onMounted よりも早いタイミング
// onBeforeMount(async () => {
//   if (!isLoginAttempted()) {
//     await getUserInfo()
//     await navigateTo(routeFullPath)
//   }
// })
</script>

<style lang="scss" scoped></style>
